import { animated, config, useTransition } from 'react-spring';
import { Button } from '../form/button';
import { Typography } from '../typography/typography';
import './filters-modal.scss';
import classNames from 'classnames';
import { isMobileOnly } from 'react-device-detect';

interface FiltersModalProps {
  isOpen: boolean;
  title: string;
  confirmText?: string;
  cancelText?: string;
  allowConfirm?: boolean;
  allowCancel?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  showConfirmButtonFirst?: boolean;
}

export const FiltersModal: React.FC<React.PropsWithChildren<FiltersModalProps>> = ({
  isOpen = false,
  title = '',
  confirmText = 'Filter',
  cancelText = 'Cancel',
  allowConfirm = true,
  allowCancel = true,
  onCancel = () => {},
  onConfirm = () => {},
  showConfirmButtonFirst = true,
  children,
}: React.PropsWithChildren<FiltersModalProps>) => {
  const modalTransition = useTransition(isOpen, {
    from: {
      opacity: 0,
      transform: 'translateX(100px)',
    },
    enter: {
      opacity: 1,
      transform: 'translateX(0px)',
    },
    leave: {
      opacity: 0,
      transform: 'translateX(100px)',
    },
    config: config.gentle,
  });

  const backgroundFadeTransition = useTransition(isOpen, {
    from: {
      opacity: 0,
    },
    enter: {
      opacity: 1,
    },
    leave: {
      opacity: 0,
    },
    config: config.gentle,
  });

  return (
    <>
      {backgroundFadeTransition((style, isOpen) => (
        <>
          {isOpen && (
            <animated.div
              style={style}
              className="quipli-v2 filters-modal-background"
              onClick={() => onCancel()}
            ></animated.div>
          )}
        </>
      ))}
      {modalTransition((style, isOpen) => (
        <>
          {isOpen && (
            <>
              <animated.div style={style} className={classNames('quipli-v2 filters-modal', { 'left-0': isMobileOnly })}>
                <div className="filters-modal-header">
                  <Typography type="text-xl" weight="medium">
                    {title}
                  </Typography>
                </div>
                <div className="filters-modal-body">{children}</div>
                <div className="filters-modal-footer">
                  {showConfirmButtonFirst && (
                    <Button
                      className={classNames('button-yellow lg full p-0', { 'mb-3': showConfirmButtonFirst })}
                      onClick={() => onConfirm()}
                      disabled={!allowConfirm}
                    >
                      <Typography type="text-md" weight="semi-bold">
                        {confirmText}
                      </Typography>
                    </Button>
                  )}
                  <Button
                    className={classNames('button-secondary lg full p-0', { 'mb-3': !showConfirmButtonFirst })}
                    onClick={() => onCancel()}
                    disabled={!allowCancel}
                  >
                    <Typography type="text-md" weight="semi-bold">
                      {cancelText}
                    </Typography>
                  </Button>
                  {!showConfirmButtonFirst && (
                    <Button
                      className="button-yellow lg full mb-3 p-0"
                      onClick={() => onConfirm()}
                      disabled={!allowConfirm}
                    >
                      <Typography type="text-md" weight="semi-bold">
                        {confirmText}
                      </Typography>
                    </Button>
                  )}
                </div>
              </animated.div>
            </>
          )}
        </>
      ))}
    </>
  );
};
